import { LiquidPill } from "components/ui/v2/liquid-pill";
import { CircleArrowUp } from "lucide-react";

interface ScrollToTopProps {
  handleScrollToTop?: () => void;
}

export default function ScrollToTop({ handleScrollToTop }: ScrollToTopProps) {
  return (
    <LiquidPill
      as="button"
      appearance="normal"
      variant="slate"
      shape="circle"
      size="lg"
      icon={<CircleArrowUp size={22} strokeWidth={1.5} />}
      onClick={handleScrollToTop}
      aria-label="Volver arriba"
    />
  );
}
